// components/DocketHeader.jsx
import React from 'react';
import { Row, Space, Typography } from 'antd';

const { Title, Text } = Typography;

const DocketHeader = ({ number }) => (
  <Row>
    <Space direction="vertical" size={0}>
      <Title style={{ margin: 0, color: '#1E2A4A' }} level={2}>
        Récapitulatif des remises
      </Title>
      <Text style={{ fontSize: 16, fontStyle: "italic", color: "#4A4A4A" }}>
        {`Nombre de remise(s): ${number}`}
      </Text>
    </Space>
  </Row>
);

export default DocketHeader;